import Button from "@components/Button";
import ScalableWrapper from "@components/ScalableWrapper";
import View from "@components/View";
import { useManager } from "@src/contexts/WarsContext";

const QuitMenuPopup = (props: { closePopup: () => void }) => {
  const { closePopup } = props;

  const manager = useManager();

  const handleQuit = async () => {
    await manager.quitToLobby();
    closePopup();
  };

  return (
    <View className="w-screen h-dvh absolute top-0 left-0 z-[999999] font-[Slackey]">
      <View
        enableEventCapturing
        className="w-full h-full absolute top-0 left-0 bg-black/60"
      />
      <ScalableWrapper maintainAspectRatioBy="height">
        <View className="w-full h-full flex items-center justify-center">
          <View
            enableEventCapturing
            className="relative bg-white w-[400px] h-[400px] p-6 rounded-xl flex flex-col items-center justify-center "
          >
            <h1 className="text-4xl text-black text-center my-0">
              Quit Game
            </h1>

            <p className="text-black text-center text-2xl leading-none px-4">
              Are you sure you want to return to the lobby?
            </p>

            <View className="flex flex-col gap-4 w-full px-8">
              <Button
                className="px-5 py-3 bg-[#FFED45] border-4 border-solid border-[#FFB218] text-black text-lg font-[Slackey] font-bold outline-none rounded-xl"
                style={{ boxShadow: "0px 4px 0px 0px #F72EC5" }}
                onClick={handleQuit}
              >
                YES
              </Button>

              <Button
                className="px-5 py-3 bg-transparent border-2 border-solid border-gray-400 text-gray-600 text-lg font-[Slackey] font-bold outline-none rounded-xl"
                onClick={closePopup}
              >
                Cancel
              </Button>
            </View>
          </View>
        </View>
      </ScalableWrapper>
    </View>
  );
};

export default QuitMenuPopup;
